import './dialog'
import './accordion'
import './embla-carousel'
import './weather'
import './currency'
import './search'

// ── Mobile off-canvas menu + search toggle ────────────────────────────────
document.addEventListener('DOMContentLoaded', function () {
  const mobileMenuToggle  = document.getElementById('mobile-menu-toggle')
  const mobileMenu        = document.getElementById('mobile-menu')
  const mobileMenuBackdrop = document.getElementById('mobile-menu-backdrop')
  const mobileMenuClose   = document.getElementById('mobile-menu-close')

  function openMobileMenu() {
    document.body.classList.add('mobile-menu-open')
    mobileMenu?.removeAttribute('inert')
    mobileMenuToggle?.setAttribute('aria-expanded', 'true')
    mobileMenuBackdrop?.setAttribute('aria-hidden', 'false')
  }

  function closeMobileMenu() {
    document.body.classList.remove('mobile-menu-open')
    mobileMenu?.setAttribute('inert', '')
    mobileMenuToggle?.setAttribute('aria-expanded', 'false')
    mobileMenuBackdrop?.setAttribute('aria-hidden', 'true')
  }

  mobileMenuToggle?.addEventListener('click', openMobileMenu)
  mobileMenuBackdrop?.addEventListener('click', closeMobileMenu)
  mobileMenuClose?.addEventListener('click', closeMobileMenu)

  // Sticky header on scroll
  const header = document.querySelector('header')
  const topBar = document.querySelector('.bg-topbar-gradient') as HTMLElement | null

  if (header) {
    let ticking = false

    function handleScroll() {
      const topBarHeight = topBar ? topBar.offsetHeight : 40
      if (window.scrollY > topBarHeight) {
        header.classList.add('sticky-header')
      } else {
        header.classList.remove('sticky-header')
      }
      ticking = false
    }

    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(handleScroll)
        ticking = true
      }
    })

    handleScroll()
  }
})
